<template>
  <section class="btm_cont contents contents_sp">
    <h1 class="ttl_contents fadein">オンラインストア</h1>
    <div class="store__container">
      <div class="store__coment">
        Foxit
        アカウントにサインインして購入手続きを行なうと、注文履歴を確認したり領収書を発行したりすることができます。<br />
        Foxit アカウントをまだお持ちでない場合は<a
          href="https://account.foxit.com/site/sign-up?al=ja_JP"
          target="_blank"
          >こちら</a
        >で作成して下さい。<br />
        アカウントにサインインせずに直接お手続き頂くことも可能です。詳細は<a href="/store/guide/" target="_blank"
          >こちら</a
        >をご覧ください。
      </div>
      <br />
      <template
        v-if="
          section.editor_license_windows.length ||
          section.editor_license_mac.length ||
          section.editor_subscription.length ||
          section.editor_upgrade.length ||
          section.editor_maintenance.length
        "
      >
        <h2 class="store__headline fadein" id="editor">Foxit PDF Editor</h2>
        <ul class="store__list">
          <li v-if="section.editor_subscription.length">
            <div class="store__products">
              <div class="store__item -buy">
                <div class="store__photo">
                  <img src="/images/product/product-bnr/bnr_Editor-Premium-1000.png" alt="Foxit PDF Editor" />
                </div>
                <div class="store__item--overview">
                  <h3 class="store__heading">サブスクリプション</h3>
                  <div class="store__comment">
                    高度な編集機能に加え、企業のニーズに応える高速性・安定性・堅牢なセキュリティ機能を備えたPDF編集ソフト Foxit PDF Editor シリーズのサブスクリプション版です。<br />
                    Foxit PDF Editor Premium では、Windows・Macのデスクトップ版を自由に組み合わせて 2デバイス選択でき、さらにCloud版・Mobile版・共有用ストレージがセットになっています。<br />
                    また、サブスクリプション版にはAzure OpenAIサービスが連携されており、PDFの活用をさらに革新します。
                  </div>
                  <a
                    class="store__nav--btn"
                    href="https://appstore.foxit.co.jp/appstore/app-detail?category=1&amp;app_code=PhantomPDF"
                    >詳細を見る</a
                  >
                </div>
              </div>
              <div class="store__feature">
                <ul class="list__disc">
                  <li>Foxit PDF Editor Premium では、Windows・Macのデスクトップ版を自由に組み合わせて2デバイス選択でき、さらにCloud版・Mobile版・共有用ストレージがセットになっています。</li>
                  <li>Foxit PDF Editor (Pro) Windows サブスクリプション、Foxit PDF Editor Mac サブスクリプションには、Cloud版・Mobile版がセットになっています。</li>
                  <li>サブスクリプション版にはAzure OpenAIサービスが連携されています。</li>
                  <li>インターネットへの接続は月1度必要です。</li>
                  <li>PDFの作成、直接文字編集、ページ編集、スタンプ機能</li>
                  <li>高度なOCR機能、編集可能なテキストPDF化、検索可能な透明テキスト付PDF化</li>
                  <li>Microsoft Office形式との相互変換機能</li>
                  <li>開封・変更不可・印刷不可などパスワード付与</li>
                  <li>電子署名によるPDFの保護</li>
                  <li>墨消し/白塗りでデータ完全削除(Pro・Macのみ)</li>
                  <li>電帳法対応アマノタイムスタンプ実装(Mac版除く)、毎月10回、最大1年間無償で利用可能</li>
                  <li>透かしをタイル状に複数行並べて表示</li>
                  <li>画像オブジェクトを外部の編集アプリケーションで編集可能</li>
                  <li>複数のPDFページを縦に繋げ 1つの画像として書き出し</li>
                  <li>PDFファイルを前回保存したバージョンに復元</li>
                  <li>ADRMS/AIP/WIP/Intuneに対応、Office365のセキュリティ運用が可能(Proのみ)</li>
                </ul>
                <ul class="list__asterisk">
                  <li>
                    Foxit PDF Editor/Pro/Mac
                    各デスクトップ版のサブスクリプションは常に最新版をご利用いただくことができ、さらにブラウザ用のFoxit
                    PDF Editor Cloudのライセンスも含まれます。
                  </li>
                  <li>Educationはドメイン(.ac.jp)(.ed.jp)(Gakunin)の方にお申込みいただけます。</li>
                </ul>
              </div>
            </div>
            <div class="store__cart">
              <ul class="store__cart--form">
                <li>
                  <ul class="store__cart--list">
                    <li v-for="a in section.editor_subscription" :key="a.id">
                      <div class="store__cart--item-name" v-html="a.name"></div>
                      <div class="store__cart--price">
                        <span class="-price">{{ a.price.toLocaleString() }}<span class="-unit">円</span></span>
                      </div>
                      <a
                        class="store__cart--btn"
                        :href="`https://appstore.foxit.co.jp/appstore/app-detail?app_code=${a.id}`"
                      >
                        <span class="-name">サブスクリプション申込</span>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul class="list__asterisk">
                <li>表示価格は全て税込です。</li>
              </ul>
            </div>
          </li>
          <li v-if="section.editor_license_windows.length || section.editor_license_mac.length">
            <div class="store__products">
              <div class="store__item -buy">
                <div class="store__photo">
                  <picture>
                    <source
                      srcset="
                        /images/product/product-bnr/bnr_DL-Win-500.png,
                        /images/product/product-bnr/bnr_DL-Win-1000.png 2x
                      "
                    />
                    <img src="/images/product/product-bnr/bnr_DL-Win-500.png" alt="Foxit PDF Reader" />
                  </picture>
                </div>
                <div class="store__item--overview">
                  <h3 class="store__heading">買い切り版</h3>
                  <div class="store__comment">
                    Foxit PDF Editorシリーズの買い切り版です。<br />
                    v13は高速性と安定性を兼ね備え、多彩なPDF作成編集機能と定評のOCR、そして堅牢なセキュリティ機能を搭載した最新のPDF編集ソフトです。<br />
                    Foxit PDF Editor v13 は、MicrosoftのAD RMS
                    による暗号化と復号の両方に対応しており、エンタープライズ企業の要求にも応えます。(Standard版は復号のみ)
                  </div>
                  <a class="store__nav--btn" href="/products/foxit-pdf-editor/">詳細を見る</a>
                </div>
              </div>
              <div class="store__feature">
                <ul class="list__disc">
                  <li>デスクトップ用アプリケーションの永久ライセンス版です。</li>
                  <li>インターネットへの接続は初回のアクティベーションコード入力時のみ</li>
                  <li>PDFの作成、直接文字編集、ページ編集、スタンプ機能</li>
                  <li>画像・図形オブジェクトの追加と高度編集※</li>
                  <li>高度なOCR機能、編集可能なテキストPDF化、検索可能な透明テキスト付PDF化</li>
                  <li>ページ領域を指定してOCRを実行※</li>
                  <li>Microsoft Office形式との相互変換機能</li>
                  <li>開封・変更不可・印刷不可などパスワード付与</li>
                  <li>電子署名によるPDFの保護</li>
                  <li>墨消し/白塗りでデータ完全削除※</li>
                  <li>電帳法対応アマノタイムスタンプ実装(Mac版除く)、毎月10回、最大1年間無償で利用可能</li>
                  <li>透かしをタイル状に複数行並べて表示</li>
                  <li>レイヤーの追加・編集※</li>
                  <li>複数のPDFページを縦に繋げ 1つの画像として書き出し</li>
                  <li>アクションウィザード※</li>
                  <li>ADRMS/AIP/WIP/Intuneに対応、Office365のセキュリティ運用が可能</li>
                  <li>ご購入から1年間のサポート付き</li>
                </ul>
                <ul class="list__asterisk">
                  <li>
                    Pro版でのみご利用いただける機能です。
                  </li>
                </ul>
              </div>
            </div>
            <div class="store__cart">
              <ul class="store__cart--form">
                <li v-if="section.editor_license_windows.length">
                  <div class="store__cart--headline -os">
                    <img src="/images/main/icon-windows.svg" alt="windows" />Windows
                  </div>
                  <ul class="store__cart--list">
                    <li v-for="a in section.editor_license_windows" :key="a.id">
                      <div class="store__cart--price">
                        <span class="-edition">{{ a.edition }}</span>
                        <span class="-price">{{ a.price.toLocaleString() }}<span class="-unit">円</span></span>
                      </div>
                      <a class="store__cart--btn" href="#" @click.prevent="addCart(a.id)">
                        <span class="-name">カートに入れる</span>
                      </a>
                    </li>
                  </ul>
                </li>
                <li v-if="section.editor_license_mac.length">
                  <div class="store__cart--headline -os"><img src="/images/main/icon-mac.svg" alt="mac" />Mac</div>
                  <ul class="store__cart--list">
                    <li v-for="a in section.editor_license_mac" :key="a.id">
                      <div class="store__cart--price">
                        <span class="-edition">{{ a.edition }}</span>
                        <span class="-price">{{ a.price.toLocaleString() }}<span class="-unit">円</span></span>
                      </div>
                      <a class="store__cart--btn" href="#" @click.prevent="addCart(a.id)">
                        <span class="-name">カートに入れる</span>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul class="list__asterisk">
                <li>表示価格は全て税込です。</li>
              </ul>
            </div>
          </li>
          <li v-if="section.editor_upgrade.length">
            <div class="store__products">
              <div class="store__item -code">
                <!-- <div class="store__photo">
                  <img src="/images/product/foxit-pdf-editor.png" alt="Foxit PDF Editor" />
                </div> -->
                <div class="store__item--overview">
                  <h3 class="store__heading">買い切りライセンスアップグレード版</h3>
                  <div class="store__comment">
                    旧製品をご使用中のお客様には、最新版をアップグレード価格にてご提供しております。<br />
                    右枠から現在お使いの製品を選択し、現在のアクティベーションコードを入力するとアップグレード価格が確認できカートへと進むことが可能です。<br />
                    対象は製品のサポート期間が切れているお客様です。
                  </div>
                  <!-- <a class="store__nav--btn" href="#">詳細を見る</a> -->
                </div>
              </div>
              <div class="store__feature">
                <ul class="list__asterisk">
                  <li>
                    ご購入1年未満のお客様は、Foxitメンテナンス＆サポートプロテクション をご指定ください。<br />
                    誤って、こちらをご購入された場合、返金処理には応じ兼ねます。
                  </li>
                  <li>
                    アクティベーションコードの入力でエラーと表示される場合は、<a href="/contact/"
                      >お問い合わせフォーム</a
                    >よりご連絡ください。
                  </li>
                  <li>
                    アップグレードは同一OSのみでのご提供となっております<br />
                    ・Windows版Standard / Editor → v13<br />
                    ・Windows版Business / Pro → v13<br />
                    ・Mac → Mac v13
                  </li>
                  <li>
                    ご購入済製品のアクティベーションコードをテキストボックスに入力して、アップグレード先の製品エディションを選択すると、価格と「カートに入れる」ボタンが表示されます。
                  </li>
                </ul>
              </div>
            </div>
            <div class="store__cart">
              <ul class="store__cart--form">
                <li>
                  <ul class="store__cart--list">
                    <li>
                      <ul class="store__cart--item-activation">
                        <li>
                          <div class="store__cart--headline -code">ご購入済製品の<br />アクティベーションコード</div>
                          <input
                            type="text"
                            placeholder="コードを入力してください"
                            v-model.trim.lazy="forms.upgrade.code"
                            :class="getClass('upgrade')"
                            @focus="resetStatus('upgrade')"
                          />
                        </li>
                        <li>
                          アップグレード後のエディション<select
                            v-model="forms.upgrade.id"
                            :class="getClass('upgrade')"
                            @change="resetStatus('upgrade')"
                          >
                            <template v-for="a in section.editor_upgrade">
                              <option :value="a.id">{{ a.edition }}</option>
                            </template>
                          </select>
                        </li>
                        <li v-if="forms.upgrade.price !== null">
                          <div class="store__cart--price">
                            <span class="-price">
                              {{ forms.upgrade.price.toLocaleString() }}<span class="-unit">円</span>
                            </span>
                          </div>
                        </li>
                        <li v-if="forms.upgrade.error !== null">
                          <span class="form-error" v-if="forms.upgrade.error === 'impossible'">
                            アップグレード対象外の商品です
                          </span>
                          <span class="form-error" v-else-if="forms.upgrade.error === 'duplicated'">
                            既にカートにあるアクティベーションコードです
                          </span>
                          <span class="form-error" v-else>アクティベーションコードが正しくありません</span>
                        </li>
                      </ul>
                      <a
                        href="#"
                        class="store__cart--btn -check"
                        :class="getClass('upgrade')"
                        @click.prevent="verifyCode('upgrade')"
                        v-if="forms.upgrade.status !== 'upgrade_verified'"
                      >
                        <span class="-name">価格を確認</span>
                      </a>
                      <a
                        class="store__cart--btn"
                        href="#"
                        @click.prevent="addCart(forms.upgrade.id, forms.upgrade.code)"
                        v-if="forms.upgrade.status === 'upgrade_verified'"
                      >
                        <span class="-name">カートに入れる</span>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul class="list__asterisk">
                <li>表示価格は全て税込です。</li>
              </ul>
            </div>
          </li>
          <li>
            <div class="store__products">
              <div class="store__item -code">
                <!-- <div class="store__photo">
                  <img src="/images/product/foxit-pdf-editor.png" alt="Foxit PDF Editor" />
                </div> -->
                <div class="store__item--overview">
                  <h3 class="store__heading">メンテナンス＆サポートプロテクション</h3>
                  <div class="store__comment">
                    こちらは、製品ご購入から1年以内のサポート期間が継続中のお客様が対象です。<br />
                    製品の使い方のご支援やPCの不具合にてアクティベーションコードの解除ができない場合のサポートや、新製品へのアップグレードを提供いたします。<br />
                    お申し込みは1年単位で延長が可能です。<br />
                    お申し込み時にはご購入時のアクティベーションコードが必要となります。<br />
                    弊社でアクティベーションコードとご購入時期を確認させていただいた上で、お手続きについてメールにてご案内いたします。<br />
                    お支払いは銀行振り込みのみとなります。<br /><br />
                    ご購入から1年以上経過しサポート期間が切れているお客様はお申し込みになれませんので、ご注意ください。
                  </div>
                  <!-- <a class="store__nav--btn" href="#">詳細を見る</a> -->
                </div>
              </div>
              <div class="store__feature">
                <ul class="list__asterisk">
                  <li>
                    アクティベーションコードの入力でエラーと表示される場合は、<a href="/contact/"
                      >お問い合わせフォーム</a
                    >よりご連絡ください。
                  </li>
                  <li>
                    対象の製品のご購入から1年以内のサポート期間が継続中のお客様が誤って、永久ライセンスアップグレード版を申し込んでしまった場合、差額の返金には応じかねますのでご了承ください。
                  </li>
                  <li>
                    ご購入済製品のアクティベーションコードをテキストボックスに入力して、お使いの製品エディションを選択すると、価格と「申し込む」ボタンが表示されます。
                  </li>
                </ul>
              </div>
            </div>
            <div class="store__cart">
              <ul class="store__cart--form">
                <li>
                  <ul class="store__cart--list">
                    <li>
                      <ul class="store__cart--item-activation">
                        <li>
                          <div class="store__cart--headline -code">ご購入済製品の<br />アクティベーションコード</div>
                          <input
                            type="text"
                            placeholder="コードを入力してください"
                            v-model.trim.lazy="forms.maintenance.code"
                            :class="getClass('maintenance')"
                            @focus="resetStatus('maintenance')"
                          />
                        </li>
                        <li>
                          現在のお使いの製品エディション<select
                            v-model="forms.maintenance.id"
                            :class="getClass('maintenance')"
                            @change="resetStatus('maintenance')"
                          >
                            <template v-for="a in section.editor_maintenance">
                              <option :value="a.id">{{ a.edition }}</option>
                            </template>
                          </select>
                        </li>
                        <li v-if="forms.maintenance.price !== null">
                          <div class="store__cart--price">
                            <span class="-price">
                              {{ forms.maintenance.price.toLocaleString() }}<span class="-unit">円</span>
                            </span>
                          </div>
                        </li>
                        <li v-if="forms.maintenance.error !== null">
                          <span class="form-error" v-if="forms.maintenance.error === 'impossible'">
                            アップグレード対象外の商品です
                          </span>
                          <span class="form-error" v-else-if="forms.maintenance.error === 'duplicated'">
                            既にカートにあるアクティベーションコードです
                          </span>
                          <span class="form-error" v-else>アクティベーションコードが正しくありません</span>
                        </li>
                      </ul>
                      <a
                        href="#"
                        class="store__cart--btn -check"
                        :class="getClass('maintenance')"
                        @click.prevent="verifyCode('maintenance')"
                        v-if="forms.maintenance.status !== 'upgrade_assurance_verified'"
                      >
                        <span class="-name">価格を確認</span>
                      </a>
                      <a
                        class="store__cart--btn"
                        href="#"
                        @click.prevent="addCart(forms.maintenance.id, forms.maintenance.code)"
                        v-if="forms.maintenance.status === 'upgrade_assurance_verified'"
                      >
                        <span class="-name">申し込む</span>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul class="list__asterisk">
                <li>表示価格は全て税込です。</li>
              </ul>
            </div>
          </li>
        </ul>
      </template>
      <template v-if="section.ifilter_windows.length">
        <h2 class="store__headline fadein" id="ifilter">Foxit PDF IFilter</h2>
        <ul class="store__list">
          <li>
            <div class="store__products">
              <div class="store__item -buy">
                <div class="store__photo">
                  <picture>
                    <source
                      srcset="
                        /images/product/product-bnr/bnr_IFilter-Server-500.png,
                        /images/product/product-bnr/bnr_IFilter-Server-1000.png 2x
                      "
                    />
                    <img src="/images/product/product-bnr/bnr_IFilter-Server-500.png" alt="Foxit PDF Editor" />
                  </picture>
                </div>
                <div class="store__item--overview">
                  <h3 class="store__heading">Foxit PDF IFilter for Server 64 bit</h3>
                  <div class="store__comment">
                    Foxit PDF IFilter は大量の PDF
                    ドキュメントインデックスを高速で作成し、条件を指定してすばやく全文検索ができるよう設計されています。<br />Microsoft
                    の IFilter と呼ばれるテキストインデックス作成のためのインターフェースに対応し、PDF
                    ドキュメントからテキストデータを高速に抽出して検索エンジンに反映します。
                  </div>
                  <a class="store__nav--btn" href="/products/foxit-server/foxit-pdf-ifilter/">詳細を見る</a>
                </div>
              </div>
              <div class="store__feature">
                <ul class="list__disc">
                  <li>高速なインデックス作成</li>
                  <li>
                    ISO 32000 PDF (PDF 1.7)、PDF-A、PDF ポートフォリオ、Adobe® PDF ファイルの インデックス作成に対応
                  </li>
                  <li>PDF 作成時の候圧縮処理</li>
                  <li>IRM セキュリティによるハイエンドなPDF 保護、動的透かし、済消しをサポート。</li>
                  <li>PDF コンテンツの抽出</li>
                  <li>PDF 文書の共有、コラボレーション機能。</li>
                  <li>フォームの入力、作成。</li>
                  <li>PDF の変換、および書き出し機能</li>
                  <li>初年度サポート付き</li>
                </ul>
                <ul class="list__asterisk">
                  <li>年間サポート込。期間後も継続利用される場合は有償サポートのご購入が必要。</li>
                </ul>
              </div>
            </div>
            <div class="store__cart">
              <ul class="store__cart--form">
                <li v-if="section.ifilter_windows.length">
                  <div class="store__cart--headline -os">
                    <img src="/images/main/icon-windows.svg" alt="windows" />Windows
                  </div>
                  <ul class="store__cart--list">
                    <li v-for="a in section.ifilter_windows" :key="a.id">
                      <div class="store__cart--price">
                        <span class="-edition">{{ a.edition }}</span>
                        <span class="-price">{{ a.price.toLocaleString() }}<span class="-unit">円</span></span>
                      </div>
                      <a class="store__cart--btn" href="#" @click.prevent="addCart(a.id)">
                        <span class="-name">カートに入れる</span>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul class="list__asterisk">
                <li>表示価格は全て税込です。</li>
              </ul>
            </div>
          </li>
        </ul>
      </template>
    </div>
    <Dialog :button="['OK:ok:success']" align="center" ref="error">
      <p v-if="message === 'overflow'">同一製品は10個まで購入できます</p>
      <p v-else-if="message === 'conflict:payment'">先にカートの内の商品を購入してください</p>
      <p v-else-if="message === 'conflict:notify'">先にカート内の商品を申し込んでください</p>
      <p v-else>製品情報の取得に失敗しました</p>
    </Dialog>
    <Dialog :button="['キャンセル:cancel:cancel', '再開する:ok:success']" align="center" explicitly="true" ref="resume">
      <p>お支払いの手続きを再開しますか？</p>
    </Dialog>
  </section>
</template>

<script>
import { fetch } from 'whatwg-fetch';
import Dialog from '@/Dialog.vue';
import source from '@/source';
import util from '@/util';

export default {
  components: { Dialog },

  data() {
    return {
      message: '',
      section: {
        editor_license_windows: [],
        editor_license_mac: [],
        editor_subscription: [],
        editor_upgrade: [],
        editor_maintenance: [],
        ifilter_windows: [],
      },
      forms: {
        upgrade: {
          status: 'unverified',
          id: '',
          code: '',
          price: null,
          error: null,
        },
        maintenance: {
          status: 'unverified',
          id: '',
          code: '',
          price: null,
          error: null,
        },
      },
    };
  },

  methods: {
    getClass(type) {
      const form = this.forms[type] ?? {};
      return {
        'form-element': true,
        disabled: form.status === 'verifying',
      };
    },

    resetStatus(type) {
      const form = this.forms[type] ?? {};
      form.status = 'unverified';
      form.price = null;
      form.error = null;
    },

    async verifyCode(type) {
      const form = this.forms[type] ?? {};
      const code = form.code.replace(/[^a-zA-Z0-9-]/g, '');
      if (form.code !== code) {
        form.code = code;
      }
      form.price = null;
      form.error = null;
      if (form.code === '') {
        return;
      } else {
        form.status = 'verifying';
      }
      const result = await source.get(`/store/${form.id}/?code=${form.code}`);
      if (result.success) {
        form.id = result.product.id;
        form.price = Math.floor(result.product.price * (1 + result.const.tax));
        form.status = result.product.upgrade_assurance ? 'upgrade_assurance_verified' : 'upgrade_verified';
      } else {
        if (result.error.match(/^conflict:/)) {
          this.message = result.error;
          await this.$refs.error.open();
        } else {
          form.error = result.error;
        }
        form.status = 'unverified';
      }
    },

    async addCart(id, code) {
      foxit.cartDialog.close();
      let query = '';
      if (typeof code === 'string' && code !== '') {
        query = `?code=${code}`;
      }
      const result = await source.post(`/store/${id}/${query}`);
      if (!result.success) {
        this.message = result.error;
        await this.$refs.error.open();
        return;
      }

      const ret = await source.get(`/store/${id}/${query}`);
      if (ret.success) {
        // Send to Google Analytics 4 (GA4)
        window.gtag('event', 'カートに入れる', {
          product: `${ret.product.name} ${ret.product.edition ?? ''}`,
        });
      }

      const reload = (foxit ?? {}).reload;
      if (typeof reload === 'function') {
        reload();
        foxit.cartDialog.open();
      }
    },

    async loadProducts() {
      const result = await source.get('/store/');
      if (!result.success) {
        await this.$refs.error.open();
        return;
      }
      result.entries.forEach((a) => {
        if (a.category === 'Foxit PDF Editor') {
          if (a.upgrade) {
            this.section.editor_upgrade.push({
              id: a.id,
              edition: a.edition,
            });
          } else if (a.upgrade_assurance) {
            this.section.editor_maintenance.push({
              id: a.id,
              edition: a.edition,
            });
          } else {
            const edition = a.edition ?? '';
            if (edition.match(/windows/i)) {
              this.section.editor_license_windows.push({
                id: a.id,
                edition: edition.match(/^Pro/) ? 'v13 Pro' : 'v13 Standard',
                price: Math.floor(a.price * (1 + a.tax)),
              });
            } else if (edition.match(/macos/i)) {
              this.section.editor_license_mac.push({
                id: a.id,
                edition: edition.match(/^Pro/) ? 'v13 Mac Pro' : 'v13 Mac',
                price: Math.floor(a.price * (1 + a.tax)),
              });
            }
          }
        } else if (a.category === 'Foxit PDF IFilter') {
          this.section.ifilter_windows.push({
            id: a.id,
            edition: a.edition,
            price: Math.floor(a.price * (1 + a.tax)),
          });
        }
      });
      if (this.section.editor_upgrade.length) {
        this.forms.upgrade.id = this.section.editor_upgrade[0].id;
      }
      if (this.section.editor_maintenance.length) {
        this.forms.maintenance.id = this.section.editor_maintenance[0].id;
      }
    },

    async loadSubscriptions() {
      this.section.editor_subscription = await Promise.all([
        fetch(
          'https://appstore.foxit.co.jp:443/api/appstore-subscription/get-plan?lang=ja-JP&app_code=pdf_editor_premium',
        )
          .then((response) => response.json())
          .then((data) => ({
            id: data[0].app_code,
            name: '<span class="-name">Foxit PDF Editor Premium</span><br /><span class="-caption">Win/Mac 2device / Cloud / Mobile</span>',
            price: data[0].price,
          })),
        fetch(
          'https://appstore.foxit.co.jp:443/api/appstore-subscription/get-plan?lang=ja-JP&app_code=phantom_ga_business',
        )
          .then((response) => response.json())
          .then((data) => ({
            id: data[0].app_code,
            name: '<span class="-name">Foxit PDF Editor (Pro) Windows</span><br /><span class="-caption">Win / Cloud / Mobile</span>',
            price: data[0].price,
          })),
        fetch('https://appstore.foxit.co.jp:443/api/appstore-subscription/get-plan?lang=ja-JP&app_code=phantom_mac')
          .then((response) => response.json())
          .then((data) => ({
            id: data[0].app_code,
            name: '<span class="-name">Foxit PDF Editor Mac</span><br /><span class="-caption">Mac / Cloud / Mobile</span>',
            price: data[0].price,
          })),
        // fetch(
        //   'https://appstore.foxit.co.jp:443/api/appstore-subscription/get-plan?lang=ja-JP&app_code=phantom_ga_online',
        // )
        //   .then((response) => response.json())
        //   .then((data) => ({
        //     id: data[0].app_code,
        //     name: 'Foxit PDF Editor Cloud',
        //     price: data[0].price,
        //   })),
        fetch(
          'https://appstore.foxit.co.jp:443/api/appstore-subscription/get-plan?lang=ja-JP&app_code=phantom_ga_education',
        )
          .then((response) => response.json())
          .then((data) => ({
            id: data[0].app_code,
            name: '<span class="-name">Foxit PDF Editor Education</span>',
            price: data[0].price,
          })),
        // fetch('https://appstore.foxit.co.jp:443/api/appstore-subscription/get-plan?lang=ja-JP&app_code=ATS')
        //   .then((response) => response.json())
        //   .then((data) => ({
        //     id: data[0].app_code,
        //     name: 'Foxit アマノタイムスタンプ 無制限サブスクリプション',
        //     price: data[0].price,
        //   })),
      ]);
    },
  },

  async created() {
    await this.$nextTick();
    if ((localStorage.getItem('token') ?? '') !== '') {
      if ((await this.$refs.resume.open()) === 'ok') {
        location.href = 'confirm.php';
        return;
      }
      localStorage.removeItem('token');
    }
    this.loadProducts();
    this.loadSubscriptions();
  },

  updated() {
    util.fadein(this.$el);
  },
};
</script>

<style lang="scss" scoped>
.form-element {
  &.disabled {
    pointer-events: none;
    opacity: 0.3;
  }
}

.form-error {
  color: #b20000;
}
</style>
